import React from 'react';
import { Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { Link } from 'react-router-dom';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { STAFFING_DASHBOARD_PATH } from 'domain/shared/core/sharedRouteConstants';

const DashboardLinkItem = ({ entity, to }: { entity: string; to: string }) => <Link to={to}>{entity}</Link>;

const DashboardBreadcrumbs = ({
  children = null,
  useStaffingPath = false,
}: {
  children?: React.ReactNode | React.ReactNode[] | null;
  useStaffingPath?: boolean;
}) => {
  const { getDashboardUrl } = useNewProjectUrl();
  const dashboardLink = useStaffingPath ? STAFFING_DASHBOARD_PATH : getDashboardUrl();

  return (
    <Breadcrumbs>
      <DashboardLinkItem entity="← Dashboard" to={dashboardLink} />
      {children}
    </Breadcrumbs>
  );
};

export default DashboardBreadcrumbs;
